import { createFileRoute, notFound } from '@tanstack/react-router';

import { findLab } from 'shared/modules/labs';
import { requireFeatureFlag } from 'shared/utils';

import { LabPage } from 'features/labs';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/labs/$labId')({
  // Labs is a menu group, not a page, so it adds no crumb. The leaf still declares a key: the
  // breadcrumb hook drops the last match as the current page, so without it the location crumb goes.
  staticData: { breadcrumb: 'labs' },
  beforeLoad: async ({ context, params: { labId } }) => {
    const lab = findLab(labId);

    if (!lab) {
      throw notFound();
    }

    // A lab that is switched off looks the same as one that does not exist.
    await requireFeatureFlag(lab.flag, context.authUser.featureAllowance, {
      onDisabled: () => {
        throw notFound();
      }
    });

    return { lab };
  },
  component: LabRoute
});

function LabRoute() {
  const { id } = Route.useParams();
  const { lab } = Route.useRouteContext();

  return <LabPage lab={lab} locationId={id} />;
}
